import {createAsyncThunk, createSlice,} from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

export const getMinCargo = createAsyncThunk(
    "Cargo/getMin",
    async ({search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("search", search);
        try {
            const response = await axios.get(
                process.env.REACT_APP_API_URL+'Master/CargoCarryingUnit/getMin',
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                let newObj = [];
                response.data.data.map((item) =>
                    newObj.push({
                        value: item.CargoCarryingUnitID,
                        label: item.CargoCarryingUnitName,
                        CategoryID: "3",
                    })
                );
                return {data: newObj};
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const getCargo = createAsyncThunk(
    "Cargo/get",
    async ({start, count, search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("start", start);
        formData.append("count", count);
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'Master/CargoCarryingUnit/getAll',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const insertCargo = createAsyncThunk(
    "Cargo/insert",
    async ({CargoCarryingUnitName, CategoryID}, thunkAPI) => {
        let formData = new FormData();
        formData.append("CargoCarryingUnitName", CargoCarryingUnitName);
        formData.append("CategoryID", CategoryID);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'Master/CargoCarryingUnit/insert',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const updateCargo = createAsyncThunk(
    "Cargo/update",
    async ({CargoCarryingUnitName, CargoCarryingUnitID, status, CategoryID}, thunkAPI) => {
        let formData = new FormData();
        formData.append("CargoCarryingUnitName", CargoCarryingUnitName);
        formData.append("CargoCarryingUnitID", CargoCarryingUnitID);
        formData.append("Status", status);
        formData.append("CategoryID", CategoryID);

        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'Master/CargoCarryingUnit/update',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

const initialState = {
    message: "",
    minData: [],
    isMinFetching: false,
    isMinSuccess: false,
    isMinError: false,
    isGetFetching: false,
    isGetSuccess: false,
    isGetError: false,
    isInsertFetching: false,
    isInsertSuccess: false,
    isInsertError: false,
    isUpdateFetching: false,
    isUpdateSuccess: false,
    isUpdateError: false,
    errorMessage: "",
};

export const CargoSlice = createSlice({
    name: "cargo",
    initialState,
    reducers: {},
    extraReducers: {
        [getMinCargo.fulfilled]: (state, {payload}) => {
            state.isMinFetching = false;
            state.isMinSuccess = true;
            state.minData = payload.data;
            return state;
        },
        [getMinCargo.rejected]: (state, {payload}) => {
            state.isMinFetching = false;
            state.isMinError = true;
            state.errorMessage = payload.message;
        },
        [getMinCargo.pending]: (state) => {
            state.isMinFetching = true;
        },

        [getCargo.fulfilled]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetSuccess = true;
            state.data = payload.data;
            state.count = payload.count;
            state.message = payload.message;
            return state;
        },
        [getCargo.rejected]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetError = true;
            state.errorMessage = payload.message;
        },
        [getCargo.pending]: (state) => {
            state.isGetFetching = true;
        },

        // INSERT
        [insertCargo.fulfilled]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [insertCargo.rejected]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertError = true;
            state.errorMessage = payload.message;
        },
        [insertCargo.pending]: (state) => {
            state.isInsertFetching = true;
        },

        // UPDATE
        [updateCargo.fulfilled]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [updateCargo.rejected]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateError = true;
            state.errorMessage = payload.message;
        },
        [updateCargo.pending]: (state) => {
            state.isUpdateFetching = true;
        },
    },
});


export const CargoSelector = (state) => state.cargo;
